import React from 'react';
import { Modal } from 'components';
import { v4 as uuidv4 } from 'uuid';
import AddActivityForm from './addClipForm';
import { useDispatch } from 'react-redux';
import { addClip } from 'store/config/activities';

interface ActivityFormProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  currentCameraId: string | undefined;
  currentCamera: any;
  videoRef: React.RefObject<HTMLVideoElement>;
  setCropDisable: React.Dispatch<React.SetStateAction<boolean>>;
  activity: any;
}

const AddActivity: React.FC<ActivityFormProps> = ({
  openModal,
  setOpenModal,
  currentCameraId,
  currentCamera,
  videoRef,
  setCropDisable,
  activity
}) => {
  const dispatch = useDispatch();
  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      title="Add Activity"
    >
      <AddActivityForm
        onSaved={(selectedActivity: string, newActivity: string) => {
          const activityId = selectedActivity || uuidv4();
          dispatch(
            addClip({
              clip_id: uuidv4(),
              cameraId: currentCameraId || '',
              activityName: newActivity,
              selectedActivity,
              newActivityId: selectedActivity ? undefined : activityId,
              videoUrl: currentCamera?.video_url || '',
              start_time: videoRef.current?.currentTime || 0,
              end_time: videoRef.current?.duration || 0,
              max_duration: videoRef.current?.duration || 0
            })
          );
          setOpenModal(false);
          setCropDisable(false);
        }}
        activities={activity}
      />
    </Modal>
  );
};

export default AddActivity;
